import { SmsGatewayModel as SmsApi } from '@/http/models/SmsGateway'
import { toast } from 'sonner'

import { useEffect, useState } from 'react'

import { SmsGatewayModel } from '@/types/model/SmsGateway'

export const useSmsGatewaysTable = () => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState<SmsGatewayModel.Gateway[]>([])
  const [gatewayDialogOpen, setGatewayDialogOpen] = useState(false)
  const [editGateway, setEditGateway] = useState<SmsGatewayModel.Gateway | null>(null)
  const [updateLoading, setUpdateLoading] = useState(false)

  const fetchGateways = async () => {
    setLoading(true)
    const response = await SmsApi.getList()
    if (response.success) {
      setData(response.data.result)
    } else {
      toast.error(response.error?.data?.message || 'Failed to fetch SMS gateways')
    }
    setLoading(false)
  }

  useEffect(() => {
    fetchGateways()
  }, [])

  const openEditDialog = (gateway: SmsGatewayModel.Gateway) => {
    setEditGateway(gateway)
    setGatewayDialogOpen(true)
  }

  const closeDialog = () => {
    setGatewayDialogOpen(false)
    setEditGateway(null)
  }

  const handleUpdateGateway = async (key: string, body: any) => {
    setUpdateLoading(true)
    const response = await SmsApi.update({
      params: { key },
      body,
    })

    if (response.success) {
      toast.success('SMS gateway updated successfully')
      closeDialog()
      fetchGateways()
    } else {
      toast.error(response.error?.data?.message || 'Failed to update SMS gateway')
    }
    setUpdateLoading(false)
  }

  return {
    loading,
    data,
    gatewayDialogOpen,
    editGateway,
    updateLoading,
    openEditDialog,
    closeDialog,
    handleUpdateGateway,
    refresh: fetchGateways,
  }
}
